import React from "react";
import JibuBot from "../components/JibuBot"
import WhyJibuBot from "../components/WhyJibuBot"
import JibuFeature from "../components/JibuFeature";
import JibuUseCases from "../components/JibuUseCases";
import HowJibuBotWorks from "../components/HowJibuBotWorks";
import JibuIntegrations from "../components/JibuIntegrations";
import JibuTestimonials from "../components/JibuTestimonials";
import JibuPricing from "../components/JibuPricing";
import JibuFAQ from "../components/JibuFAQ";
import JibuCTA from "../components/JibuCTA";

const HomePage = ({ isDarkMode }) => {
 

  return (
    <>
      <JibuBot isDarkMode={isDarkMode} />
      <WhyJibuBot isDarkMode={isDarkMode} />
      <JibuFeature isDarkMode={isDarkMode} />
      <JibuUseCases isDarkMode={isDarkMode} />
      <HowJibuBotWorks isDarkMode={isDarkMode} />
      <JibuIntegrations isDarkMode={isDarkMode} />
      {/*<JibuTestimonials isDarkMode={isDarkMode} />*/}
      <JibuPricing isDarkMode={isDarkMode} />
      <JibuFAQ isDarkMode={isDarkMode} />
      <JibuCTA isDarkMode={isDarkMode} />

 
    

    </>
  );
};

export default HomePage;
